// Drawer-based navigation for narrow viewports. Header variants render
// this with a hamburger trigger that's hidden on md+ via AntD's
// useBreakpoint() hook in the parent. The drawer auto-closes on route
// change so users don't have to dismiss it manually.
import { useEffect } from 'react';
import { Drawer } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@core/hooks/useAuth';
import { useActiveCart } from '@core/hooks/useCart';
import Button from '@components/base/Button';
import Badge from '@components/base/Badge';
import { useCopy } from '@/app/providers/useCopy';

export default function MobileNav({ open, onClose, items = [], title, className, extraContent }) {
  const t = useCopy();
  const { isAuthenticated } = useAuth();
  const { lineCount } = useActiveCart();
  const { pathname } = useLocation();

  // Auto-close when the user navigates — covers Link clicks, programmatic
  // navigation, and browser back/forward in a single place.
  useEffect(() => {
    if (open) onClose?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <Drawer
      title={
        title || (
          <div
            className="default-mobile-drawer-brand"
            style={{ fontWeight: 700, fontSize: '1.1rem' }}
          >
            Menu
          </div>
        )
      }
      placement="left"
      open={open}
      onClose={onClose}
      width={300}
      className={`default-mobile-drawer ${className || ''}`}
      closable={true}
    >
      <div className="fish-mobile-nav-content">
        {extraContent ? (
          <div className="mobile-nav-extra" style={{ marginBottom: '1rem' }}>
            {extraContent}
          </div>
        ) : null}
        <nav className="fish-mobile-nav-links">
          {items.map((n) => (
            <Link key={n.to} to={n.to} className="fish-mobile-nav-link">
              {n.label}
            </Link>
          ))}

          <Link to="/cart" className="fish-mobile-nav-link fish-mobile-nav-cart">
            <span>Cart</span>
            {lineCount > 0 ? (
              <Badge variant="custom" color="processing" label={String(lineCount)} />
            ) : null}
          </Link>
        </nav>

        <div className="fish-mobile-nav-footer">
          {isAuthenticated ? (
            <div className="fish-mobile-nav-auth-links">
              <Link to="/account" className="fish-mobile-nav-link">
                Account
              </Link>
              <Link to="/orders" className="fish-mobile-nav-link">
                Orders
              </Link>
            </div>
          ) : (
            <div className="fish-mobile-nav-auth-buttons">
              <Link to="/login">
                <Button block>{t('signIn')}</Button>
              </Link>
              <Link to="/signup">
                <Button type="primary" block>
                  {t('signUp')}
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </Drawer>
  );
}
